import { useS4LContext } from '@s4l/react-context'
import type { UseCaseEvent } from '@s4l/stayforlong'
import type { SearchMetadata } from '@s4l/stayforlong/property/domain/SearchMetadata'
import { useUseCase } from '@s4l/utils/hooks/useUseCase'
import { useCallback, useEffect, useState } from 'react'

export const useSearchMetadata = () => {
  const { domain } = useS4LContext()
  const [searchMetadata, setSearchMetadata] = useState<SearchMetadata>()

  const {
    data: featureFlag,
    error: errorFeatureFlag,
    loading: loadingFeatureFlag,
  } = useUseCase('GetFeatureFlagByNameSharedUseCase', {
    name: 'FILTERS_AGGREGATIONS',
  })

  const {
    data: market,
    error: errorMarket,
    loading: loadingMarket,
  } = useUseCase('GetCurrentMarketSharedUseCase')

  const updateSearchMetadata = useCallback(
    async ({ response }: UseCaseEvent<'SearchFromPartialAndCriteriaPropertyUseCase'>) => {
      if (loadingFeatureFlag || errorFeatureFlag || featureFlag?.isDisabled()) return

      if (loadingMarket || errorMarket || !market) return

      const ffMarkets = featureFlag?.metadata?.market as string[] | undefined

      if (!ffMarkets?.some(m => m === market.value)) return

      const [errorSearch, search] = response

      if (errorSearch) return
      setSearchMetadata(search.metadata)
    },
    [loadingFeatureFlag, errorFeatureFlag, featureFlag, loadingMarket, errorMarket, market]
  )

  useEffect(() => {
    domain.on('SearchFromPartialAndCriteriaPropertyUseCase', updateSearchMetadata)

    return () => {
      domain.off('SearchFromPartialAndCriteriaPropertyUseCase', updateSearchMetadata)
    }
  }, [domain, updateSearchMetadata])

  return {
    loadingFeatureFlag,
    searchMetadata,
  }
}
